import { useNavigate } from "react-router-dom";

// This page (/userprofilemanager/*) is a manager's own employee profile — it
// always renders the same "employee profile" content no matter what viewType
// used to hold, so there is nothing to toggle in place here. "user" is simply
// the permanent, correct label for whatever is on screen while this page is
// mounted (matches getCurrentView() in notificationNavigation.js, which
// treats this whole route prefix as view "user" unconditionally).
//
// "manager"/"admin" both belong to a DIFFERENT shell (/DashboardManager/*,
// see Manager_Account/index.jsx), which renders Manager View and Admin View
// itself without changing route — /userprofileadmin and /dashboard are
// admin-role-only routes (PrivateRoute) and a real "manager" account can
// never reach them, so navigating there always got rejected and bounced
// elsewhere, which is what made the switcher/content disagree.
export const useViewType = (profile) => {
  const navigate = useNavigate();
  const viewType = "user";

  const hasAdminLevel = () => {
    try {
      const adminLevelData = localStorage.getItem("adminLevel");
      if (adminLevelData) {
        const adminLevel = JSON.parse(adminLevelData);
        return adminLevel && (adminLevel.modules?.length > 0 || adminLevel.adminLevelId);
      }
    } catch (error) {
      console.error("Error checking admin level:", error);
      return false;
    }
    return false;
  };

  const handleViewTypeChange = (type) => {
    if (type === "manager" || type === "admin") {
      // Persist the requested sub-view before navigating so Manager_Account
      // initializes as 'manager' or 'admin' on arrival instead of whatever
      // was last left in storage.
      localStorage.setItem("managerViewType", type);
      localStorage.setItem("viewType", type);
      navigate("/DashboardManager/dashboard");
    }
    // "user" is already the (only) view this page shows — nothing to do.
  };

  return { viewType, handleViewTypeChange, hasAdminLevel };
};
